import { combineReducers } from "redux";
import getEvents from "./events";
import onedayEvents from "./singledayEvent";

const EventsReducer = combineReducers({ getEvents, onedayEvents });

export default EventsReducer;
